import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, concatMap, filter, tap, of } from 'rxjs'
import { handleMessages, refreshToken } from '../../modules/client/utilities'

export default {
  namespaced: true,
  state: () => ({
    onlineDeposits: [],
    withdrawals: [],
    betDetails: [],
    selectedBetDetail: {},
    indoorTransfers: [],
    promotionActivities: [],
    selfHelpBackwaters: [],
    bonusAccounts: []
  }),
  actions: {
    getRecords(context, payload) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/report/queryHistory`,
                {
                  ...payload
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    initBetDetail({ commit }) {
      commit('BET_DETAILS', [])
      commit('SELECTED_BET_DETAIL', {})
    },
    getBetDetails(
      context,
      { startDate, endDate, platform, pageSize, pageIndex }
    ) {
      const { commit, state } = context
      const data = {
        startDateTime: startDate,
        endDateTime: endDate,
        pageSize,
        pageIndex
      }
      if (platform) {
        data.platform = platform
      }

      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/gameData/findSinglePlayerAllBetDetail`,
                data,
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('BET_DETAILS', data.betDetails || [])
          }),
          concatMap(({ data }) =>
            of({
              data: state.betDetails,
              total: data.totalCount || 0
            })
          )
        )
        .toPromise()
    },
    getBetDetail(context, { id, platform }) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/gameData/findById`,
                {
                  id,
                  platform
                },
                getAxiosConfig(context)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('SELECTED_BET_DETAIL', data || {})
          })
        )
        .toPromise()
    }
  },
  mutations: {
    ONLINE_DEPOSITS(state, payload) {
      state.onlineDeposits = payload
    },
    WITHDRAWALS(state, payload) {
      state.withdrawals = payload
    },
    BET_DETAILS(state, payload) {
      state.betDetails = payload
    },
    SELECTED_BET_DETAIL(state, payload) {
      state.selectedBetDetail = payload
    },
    INDOOR_TRANSFERS(state, payload) {
      state.indoorTransfers = payload
    },
    PROMOTION_ACTIVITIES(state, payload) {
      state.promotionActivities = payload
    },
    SELF_HELP_BACKWATERS(state, payload) {
      state.selfHelpBackwaters = payload
    },
    BONUS_ACCOUNTS(state, payload) {
      state.bonusAccounts = payload
    }
  },
  getters: {
    onlineDeposits: state => state.onlineDeposits,
    withdrawals: state => state.withdrawals,
    betDetails: state => state.betDetails,
    selectedBetDetail: state => state.selectedBetDetail,
    indoorTransfers: state => state.indoorTransfers,
    promotionActivities: state => state.promotionActivities,
    selfHelpBackwaters: state => state.selfHelpBackwaters,
    bonusAccounts: state => state.bonusAccounts
  }
}
